export default __webpack_public_path__ + "static/journey-5277b6761d45f04c0aef249186deb2a3.webp";